/* ============================================================
   FH — Windbreaker Bundle  v2026-08-17  BUY 2 FOR $160
   File: assets/fh-bundle.js
   Loaded by snippets/fh-bundle-selector.liquid (defer).

   Tiers:  1 set $120  ·  2 sets $160   (duo pre-selected)
   The 3-set tier was removed 2026-08-11 by operator decision.

   WHAT CHANGED vs v2026-08-11 — two defects found live 2026-08-17:

   1. DEAD PRIMARY CTA on all four windbreaker PDPs. The duo tier is
      pre-selected, but its partner slot booted with variantId=null, so
      syncNativeAtc() rendered the theme's Add-to-bag as "Pick set two" and the
      shopper's FIRST click could not buy anything. defaultSlot() now gives the
      partner slot a real, addable variant on first paint — mirroring set one's
      size, which is the overwhelmingly likely intent — so the CTA reads
      "Add 2 sets — $160" and works immediately. Set two keeps following set
      one's size until the shopper picks its own.

   2. FAIL-OPEN PRICING. readKachingTotal() returning null used to leave the
      Liquid numbers standing. That was safe only while the render gate and the
      deal's target set were the same four handles. It is now a coverage GATE
      that fails CLOSED — see the block marked "coverage gate" below.
      This is what makes it safe to render the bundle on windbreakers that are
      not in the Kaching deal yet: they simply show no bundle until they are.

   DISCOUNT SOURCE: the Kaching Bundles app, server-side, from the
   __kaching_bundles line-item properties this script stamps.

   PRICE TRUTH — reconcilePricing().
   The theme cannot discount anything, it can only display. Rather than trust
   the Liquid constant to stay in sync with the Kaching admin, this script reads
   the LIVE deal JSON that Kaching server-renders into the page
   (script.kaching-bundles-deal-block-settings), finds OUR deal's qty-2
   quantity-break bar, and rewrites every displayed number — and the
   data-fh-tier-* attributes the ATC label is built from — to whatever Kaching
   will actually charge. Liquid supplies the intent and the first paint; Kaching
   is the authority. The root element records which one won in
   data-fh-price-source, so a rendered-HTML check can see it without a browser.

   Consequence: the PDP cannot advertise a price the cart won't honour, and when
   the operator changes the bar in the Kaching admin the PDP follows on the next
   page load with no redeploy.

   Kaching deal a41f4642-4581-4ce2-984c-b58235eb1d85, re-read off a live PDP
   2026-08-17 (supersedes the 2026-08-11 note, which is now stale in both bars):
     Bar tY2D qty1 default · Bar SgwX qty2 specific $160 · Bar Z3DO qty3 specific $240
     blockVisibility="selected-products", selectedCollectionIds=[]
   SgwX is $160 — the intended offer is live. Z3DO was repriced $180 -> $240
   (3 x $80), so the old "stale page can buy 3 sets for $180" leak is closed.
   ============================================================ */
(function () {
  'use strict';

  var KACHING = {
    deal: 'a41f4642-4581-4ce2-984c-b58235eb1d85', // data-deal-block-id
    v: 'd6f4fb1f1aa908'                            // deal instance (radio name token)
  };

  var root = document.getElementById('fh-bundle');
  if (!root) return;

  /* ---------- data ---------- */
  var dataEl = root.querySelector('[data-fh-bundle-json]');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var products = data.products || [];
  if (!products.length) return;

  var currentHandle = root.getAttribute('data-current-handle');

  /* ---------- coverage gate — FAIL CLOSED ----------
     The Kaching app embed server-renders its settings <script> on EVERY product,
     but leaves the body EMPTY for a product outside the deal's target set
     (measured 2026-08-17: 6284 chars on a covered PDP, 0 on an uncovered one).
     So a populated, id-matching block carrying a usable qty-2 bar is the only
     honest proof that the cart will actually price this bundle.

     If that proof is missing this product is not in the deal, so we show nothing
     and touch nothing: no bundle card, no tier state, and — critically — no
     hijack of the theme's own Add-to-bag button. syncNativeAtc() would otherwise
     relabel it "Add 2 sets — $160" while activeTier is the pre-selected 'duo',
     and bindNativeAtc() would preventDefault the shopper's click into a bundle
     add that Kaching will not discount. Hiding the card alone is NOT enough.

     A plain $120 PDP is a worse page. A PDP that advertises $160 and charges
     $240 is a worse business, and is the exact failure SITE_GUIDE.md forbids.

     This also means coverage is self-healing in both directions with no deploy:
     add a product to the deal in the Kaching admin and its bundle appears on the
     next page load; drop one and its PDP stops making the claim by itself. */
  if (readKachingTotal(2) === null) {
    root.setAttribute('data-fh-bundle-coverage', 'none');
    root.setAttribute('hidden', 'hidden');
    root.style.display = 'none';
    return;
  }
  root.setAttribute('data-fh-bundle-coverage', 'ok');
  root.removeAttribute('hidden');
  root.style.display = '';

  /* Deploy-window compatibility: if the older three-tier markup is still being
     served (asset and snippet cannot land in the same instant), drop the trio
     tier rather than leave a selectable option this build can no longer add. */
  var staleTrio = root.querySelector('[data-fh-tier="trio"]');
  if (staleTrio && staleTrio.parentNode) staleTrio.parentNode.removeChild(staleTrio);

  /* ---------- tiers ---------- */
  var SLOTS_BY_TIER = { single: [], duo: ['d2'] };
  var ALL_SLOTS = ['d2'];

  function tierEl(t) { return root.querySelector('[data-fh-tier="' + t + '"]'); }
  function tierCfg(t) {
    var e = tierEl(t);
    if (!e) return { qty: 1, total: NaN };
    return {
      qty: parseInt(e.getAttribute('data-fh-tier-qty'), 10) || 1,
      total: parseFloat(e.getAttribute('data-fh-tier-total')),
      each: parseFloat(e.getAttribute('data-fh-tier-each'))
    };
  }
  function money(n) {
    if (!isFinite(n)) return '';
    return '$' + (Math.round(n * 100) / 100).toString().replace(/\.0+$/, '');
  }

  /* ---------- price reconciliation against the live Kaching deal ---------- */

  /* Returns the qty-2 fixed total Kaching will actually charge, or null if the
     deal block is absent / unparseable / has no matching bar — in which case the
     Liquid-rendered values stand. Matched by DEAL ID first so another deal's
     block on the same page can never price this bundle. */
  function readKachingTotal(qty) {
    var wantDeal = root.getAttribute('data-fh-deal-id') || KACHING.deal;
    var blocks = document.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var i = 0; i < blocks.length; i++) {
      var deal;
      try { deal = JSON.parse(blocks[i].textContent); } catch (e) { continue; }
      if (!deal || deal.id !== wantDeal || !Array.isArray(deal.dealBars)) continue;
      for (var j = 0; j < deal.dealBars.length; j++) {
        var bar = deal.dealBars[j];
        if (!bar || bar.dealBarType !== 'quantity-break') continue;
        if (Number(bar.quantity) !== qty) continue;
        if (bar.discountType !== 'specific') continue;
        var total = Number(bar.discountValue);
        if (!isFinite(total) || total <= 0) continue;
        return total;
      }
    }
    return null;
  }

  function setPriceNodes(field, text) {
    var nodes = root.querySelectorAll('[data-fh-price="' + field + '"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
  }

  function reconcilePricing() {
    var duo = tierEl('duo');
    if (!duo) return;

    var qty = parseInt(duo.getAttribute('data-fh-tier-qty'), 10) || 2;
    var retail = parseFloat(duo.getAttribute('data-fh-tier-retail'));
    var declared = parseFloat(duo.getAttribute('data-fh-tier-total'));
    var live = readKachingTotal(qty);

    if (live === null) {
      root.setAttribute('data-fh-price-source', 'liquid');
      return;
    }
    root.setAttribute('data-fh-price-source', 'kaching');
    if (live === declared) return;

    console.warn('[fh-bundle] price reconciled: theme declared ' + money(declared) +
                 ', Kaching bar charges ' + money(live) + ' for ' + qty +
                 ' sets. Displaying Kaching. Change bar SgwX to ' + money(declared) +
                 ' in the Kaching admin to run the intended offer.');

    var each = live / qty;
    duo.setAttribute('data-fh-tier-total', String(live));
    duo.setAttribute('data-fh-tier-each', String(Math.round(each * 100) / 100));

    setPriceNodes('total', money(live));
    setPriceNodes('each', money(each));
    if (isFinite(retail) && retail > 0) {
      var save = retail - live;
      setPriceNodes('was', money(retail));
      setPriceNodes('save', money(save));
      setPriceNodes('pct', String(Math.round(save / retail * 100)));
      /* A bar that saves nothing must not shout about savings. */
      if (save <= 0) {
        var callouts = root.querySelectorAll('.fh-savings, .fh-tier__save');
        for (var i = 0; i < callouts.length; i++) callouts[i].style.display = 'none';
      }
    }
  }

  /* ---------- state: one entry per slot ----------
     ownSize: the shopper explicitly chose set two's size, so it stops mirroring
     set one. Never set by any code path other than a real click on a partner
     size button. */
  var state = {};
  ALL_SLOTS.forEach(function (slot, n) {
    state[slot] = { pIdx: 0, color: null, size: null, variantId: null, ownSize: false };
    /* Default the partner slot to a DIFFERENT colourway than the one being
       viewed, so the picker reads as a real choice rather than a duplicate. */
    var others = [];
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle !== currentHandle) others.push(i);
    }
    if (others.length) state[slot].pIdx = others[n % others.length];
  });

  /* ---------- option helpers ---------- */
  function opt(p, name) {
    for (var i = 0; i < p.options.length; i++) {
      if ((p.options[i] || '').toLowerCase() === name) return i;
    }
    return -1;
  }
  function colorIdx(p) { var i = opt(p, 'color'); if (i < 0) i = opt(p, 'colour'); return i; }
  function sizeIdx(p) {
    for (var i = 0; i < p.options.length; i++) {
      var n = (p.options[i] || '').toLowerCase();
      if (n !== 'color' && n !== 'colour' && n !== 'title') return i;
    }
    return -1;
  }
  function vOpt(v, idx) { return idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3; }

  function colorsOf(p) {
    var ci = colorIdx(p); if (ci < 0) return [];
    var seen = {}, out = [];
    p.variants.forEach(function (v) {
      var val = vOpt(v, ci);
      if (!(val in seen)) { seen[val] = true; out.push({ value: val, image: v.image || p.image }); }
    });
    return out;
  }
  function sizesOf(p, color) {
    var si = sizeIdx(p), ci = colorIdx(p);
    if (si < 0) return [];
    var seen = {}, out = [];
    p.variants.forEach(function (v) {
      if (ci >= 0 && color !== null && vOpt(v, ci) !== color) return;
      var val = vOpt(v, si);
      if (!(val in seen)) { seen[val] = out.length; out.push({ value: val, available: false }); }
      if (v.available) out[seen[val]].available = true;
    });
    return out;
  }
  function resolveVariant(p, color, size) {
    var si = sizeIdx(p), ci = colorIdx(p);
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (!v.available) continue;
      if (ci >= 0 && color !== null && vOpt(v, ci) !== color) continue;
      if (si >= 0 && size !== null && vOpt(v, si) !== size) continue;
      return v.id;
    }
    return null;
  }

  /* Set one's currently selected size, read off the theme's own size picker. */
  function mainSelectedSize() {
    var btn = document.querySelector('.fh-pdp__size.is-selected') ||
              document.querySelector('.fh-pdp__size[aria-pressed="true"]');
    if (btn) {
      var v = btn.getAttribute('data-value') || btn.textContent || '';
      return v.trim() || null;
    }
    var lbl = document.getElementById('size-label');
    var t = lbl ? (lbl.textContent || '').trim() : '';
    return t || null;
  }

  /* Give the partner slot a real, ADDABLE variant so the primary CTA is live on
     first paint. Before this, the duo tier booted pre-selected but empty, so the
     theme's Add-to-bag rendered "Pick set two" on every windbreaker PDP and the
     shopper's first click bought nothing.

     Preference order:
       1. a size the shopper picked themselves, if still in stock here
       2. set one's size — same body, same set, almost always what they want
       3. the partner's first in-stock size
       4. nothing (every size sold out) — CTA correctly falls back to "Pick set two"
     Only ever selects an AVAILABLE size, so this can never produce an
     add-to-cart that 422s on a sold-out variant. */
  function defaultSlot(slot) {
    var st = state[slot];
    var p = products[st.pIdx];
    if (!p) return;

    var sizes = sizesOf(p, st.color);
    if (!sizes.length) {                       // sizeless product
      st.size = null;
      st.variantId = resolveVariant(p, st.color, null);
      return;
    }

    var avail = {};
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i].available) avail[sizes[i].value] = true;
    }

    var pick = null;
    if (st.ownSize && st.size && avail[st.size]) {
      pick = st.size;
    } else {
      var want = mainSelectedSize();
      if (want && avail[want]) pick = want;
    }
    if (!pick) {
      for (var j = 0; j < sizes.length; j++) {
        if (sizes[j].available) { pick = sizes[j].value; break; }
      }
    }

    st.size = pick;
    st.variantId = pick ? resolveVariant(p, st.color, pick) : null;
  }

  /* main product form's live variant id (the theme keeps this input synced) */
  function mainVariantId() {
    var input = document.querySelector('[data-fh-variant-id]') ||
                document.querySelector('#fh-pdp-form input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  /* ---------- elements ---------- */
  function el(name, slot) { return root.querySelector('[data-fh-bundle-' + name + '="' + slot + '"]'); }
  var elAtc     = root.querySelector('[data-fh-bundle-atc]');
  var elErr     = root.querySelector('[data-fh-bundle-err]');
  var elCurrent = root.querySelector('[data-fh-bundle-current]');
  var tiers     = root.querySelectorAll('[data-fh-tier]');

  var activeTier = 'duo'; // pre-selected

  function activeSlots() { return SLOTS_BY_TIER[activeTier] || []; }
  function isBundleTier() { return activeSlots().length > 0; }

  function setTier(t) {
    if (!SLOTS_BY_TIER.hasOwnProperty(t)) return;
    activeTier = t;
    for (var i = 0; i < tiers.length; i++) {
      var on = tiers[i].getAttribute('data-fh-tier') === t;
      tiers[i].classList.toggle('is-active', on);
      var head = tiers[i].querySelector('[data-fh-tier-btn]');
      if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (elErr) elErr.hidden = true;
    refresh();
  }

  /* Delegated so any tier control added later is picked up without rebinding. */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fh-tier-btn]') : null;
    if (!btn || !root.contains(btn)) return;
    setTier(btn.getAttribute('data-fh-tier-btn'));
  });

  /* ---------- render, per slot ---------- */
  function renderProducts(slot) {
    var host = el('products', slot);
    if (!host) return;
    var st = state[slot];
    host.innerHTML = '';
    products.forEach(function (p, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fh-bundle__product' + (idx === st.pIdx ? ' is-active' : '');
      b.style.backgroundImage = "url('" + (p.image || '') + "')";
      b.setAttribute('aria-label', p.title);
      b.title = p.title;
      b.addEventListener('click', function () {
        /* Keep st.size: switching colourway should carry the shopper's size over
           when the new one stocks it. defaultSlot re-resolves and falls back if
           it does not. Nulling it here is what used to strand the CTA. */
        st.pIdx = idx; st.color = null; st.variantId = null;
        renderSlot(slot); refresh();
      });
      host.appendChild(b);
    });
    var prev = el('preview', slot);
    if (prev) {
      var pp = products[st.pIdx];
      prev.src = (pp && pp.image) || '';
      prev.alt = (pp && pp.title) || '';
    }
  }

  function renderSwatches(slot) {
    var host = el('swatches', slot);
    if (!host) return;
    var st = state[slot];
    var p = products[st.pIdx];
    var colors = colorsOf(p);
    host.innerHTML = '';
    if (!colors.length) { host.style.display = 'none'; return; }
    host.style.display = '';
    if (st.color === null) st.color = colors[0].value;
    colors.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fh-bundle__swatch' + (c.value === st.color ? ' is-active' : '');
      b.style.backgroundImage = "url('" + (c.image || '') + "')";
      b.setAttribute('aria-label', c.value);
      b.title = c.value;
      b.addEventListener('click', function () {
        st.color = c.value; st.variantId = null;
        var prev = el('preview', slot);
        if (prev && c.image) prev.src = c.image;
        renderSwatches(slot); defaultSlot(slot); renderSizes(slot); refresh();
      });
      host.appendChild(b);
    });
  }

  function renderSizes(slot) {
    var host = el('sizes', slot);
    if (!host) return;
    var st = state[slot];
    var p = products[st.pIdx];
    var sizes = sizesOf(p, st.color);
    host.innerHTML = '';
    if (!sizes.length) {
      st.size = null;
      st.variantId = resolveVariant(p, st.color, null);
      return;
    }
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fh-bundle__size' + (s.value === st.size ? ' is-active' : '') + (s.available ? '' : ' is-out');
      b.textContent = s.value;
      if (!s.available) { b.disabled = true; }
      else {
        b.addEventListener('click', function () {
          st.size = s.value;
          st.ownSize = true;          // stop mirroring set one from here on
          st.variantId = resolveVariant(p, st.color, s.value);
          renderSizes(slot); refresh();
        });
      }
      host.appendChild(b);
    });
  }

  function renderSlot(slot) {
    renderProducts(slot);
    renderSwatches(slot);
    defaultSlot(slot);              // must precede renderSizes so the pick paints active
    renderSizes(slot);
  }

  /* Set two follows set one's size until the shopper gives set two its own.
     The theme's size buttons are plain <button>s, so there is no change event to
     listen for. The 0ms defer lets the theme's own handler move .is-selected
     before we read it. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.fh-pdp__size') : null;
    if (!t || root.contains(t)) return;
    setTimeout(function () {
      ALL_SLOTS.forEach(function (s) {
        if (!el('products', s)) return;
        defaultSlot(s);
        renderSizes(s);
      });
      refresh();
    }, 0);
  });

  /* Slots for the ACTIVE tier that still have no variant chosen. */
  function missingSlots() {
    return activeSlots().filter(function (s) { return !state[s].variantId; });
  }

  function refresh() {
    if (elAtc) elAtc.style.display = 'none';
    syncNativeAtc();
    var label = document.getElementById('color-label');
    var txt = label ? label.textContent : '';
    if (elCurrent) elCurrent.textContent = txt || 'as selected';
  }

  /* ---------- drawer control (self-sufficient) ---------- */
  function fhOpenDrawer() {
    var d = document.getElementById('drawer');
    var o = document.getElementById('overlay');
    if (!d) { window.location.href = '/cart'; return false; }
    d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return true;
  }
  function fhCloseDrawer() {
    var d = document.getElementById('drawer');
    var o = document.getElementById('overlay');
    if (d) d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function fhRefreshDrawerSelf() {
    return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pairs = ['#drawer-items', '[data-cart-subtotal]', '[data-cart-total]', '[data-cart-count]', '.drawer__footer', '.drawer-footer'];
        pairs.forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var live  = document.querySelector(sel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function (e) { console.warn('[fh-bundle] self-refresh failed', e); });
  }

  var _fhDrawerBound = false;
  function bindDrawerControls() {
    if (_fhDrawerBound) return;
    _fhDrawerBound = true;
    var drawer  = document.getElementById('drawer');
    var overlay = document.getElementById('overlay');

    if (overlay) overlay.addEventListener('click', fhCloseDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) fhCloseDrawer();
    });

    if (drawer) drawer.addEventListener('click', function (e) {
      var t = e.target.closest(
        '[data-drawer-close],.drawer__close,.drawer-close,.js-drawer-close,[aria-label*="lose"],[class*="close"]'
      );
      if (t && drawer.contains(t)) { e.preventDefault(); fhCloseDrawer(); }
    });

    var cartIcon = document.querySelector(
      'header a[href$="/cart"], .header a[href$="/cart"], #cart-icon-bubble, [data-cart-toggle], .header__icon--cart'
    );
    if (cartIcon) cartIcon.addEventListener('click', function (e) {
      if (typeof window.openFhDrawer === 'function') return;
      if (!document.getElementById('drawer')) return;
      e.preventDefault();
      fhRefreshDrawerSelf().then(fhOpenDrawer);
    });
  }

  /* ---------- add ---------- */
  function bundleId() {
    return 'fh' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  /* Kaching identifies bundle line items by these hidden properties. Every line
     in the bundle shares one bid so Kaching ties them into a single bundle
     instance and picks the matching quantity bar server-side. */
  function propsMain(bid) {
    return { '__kaching_bundles': JSON.stringify({ deal: KACHING.deal, main: true, v: KACHING.v, id: bid, bid: bid }) };
  }
  function propsPartner(bid) {
    return { '__kaching_bundles': JSON.stringify({ id: bid, deal: KACHING.deal, v: KACHING.v, bid: bid, collectionBreaksProduct: true }) };
  }

  /* One latch for the whole module, not per-button: the capture-phase document
     listener can catch a DIFFERENT add-to-cart button (sticky bar vs inline)
     than the one already disabled, and a fast double-click on either would
     otherwise put two bundles — four lines — in the cart. */
  var isAdding = false;

  function doBundleAdd(feedbackBtn) {
    if (isAdding) return;

    var mainId = mainVariantId();
    var slots = activeSlots();
    var missing = missingSlots();

    if (missing.length) {
      if (elErr) { elErr.textContent = 'Pick set two to continue.'; elErr.hidden = false; }
      var picker = el('products', missing[0]);
      if (picker && picker.scrollIntoView) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!mainId) {
      if (elErr) { elErr.textContent = 'Pick your size on set one first.'; elErr.hidden = false; }
      return;
    }
    if (elErr) elErr.hidden = true;

    isAdding = true;

    var btn = feedbackBtn || null;
    var prevHtml = btn ? btn.innerHTML : '';
    var prevDisabled = btn ? btn.disabled : false;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); setBtnText(btn, 'Adding…'); }

    function release() {
      isAdding = false;
      if (btn) { btn.innerHTML = prevHtml; btn.disabled = prevDisabled; btn.removeAttribute('aria-busy'); }
    }

    var bid = bundleId();
    var items = [{ id: mainId, quantity: 1, properties: propsMain(bid) }];
    slots.forEach(function (s) {
      items.push({ id: state[s].variantId, quantity: 1, properties: propsPartner(bid) });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error(res.json && res.json.description ? res.json.description : 'Could not add to cart');

      function openAfter() {
        if (typeof window.openFhDrawer === 'function') window.openFhDrawer();
        else fhOpenDrawer();
      }

      var refreshP;
      if (typeof window.fhRefreshDrawer === 'function') {
        try { refreshP = window.fhRefreshDrawer(); } catch (e) { console.warn('[fh-bundle] their refresh threw', e); }
      }
      if (!refreshP || typeof refreshP.then !== 'function') refreshP = fhRefreshDrawerSelf();

      /* Release BEFORE the drawer paints, so the button can never be left
         disabled behind an open drawer. */
      release();
      refreshP.then(openAfter).catch(openAfter);
    })
    .catch(function (e) {
      if (elErr) { elErr.textContent = (e && e.message) ? e.message : 'Something went wrong — try again.'; elErr.hidden = false; }
      release();
    });
  }

  if (elAtc) elAtc.addEventListener('click', function () { doBundleAdd(elAtc); });

  /* ---------- native bottom ATC hijack (tier-aware) ----------
     1 set   -> the theme's Add to Cart runs untouched.
     2 sets  -> we preempt it and add the whole bundle. */

  function isCartUI(elm) {
    return !!(elm.closest && elm.closest('#drawer, #overlay, #fh-bundle, [class*="drawer"], [class*="cart-drawer"], [data-cart-drawer]'));
  }
  function looksLikeAtc(elm) {
    if (!elm || elm.nodeType !== 1) return false;
    if (isCartUI(elm)) return false;
    var tag = elm.tagName;
    var isBtnish = tag === 'BUTTON' || tag === 'INPUT' || elm.getAttribute('role') === 'button';
    if (!isBtnish) return false;
    var cls = (elm.className && elm.className.baseVal !== undefined) ? elm.className.baseVal : ('' + (elm.className || ''));
    if (elm.matches('[name="add"], .product-form__submit, .fh-pdp__atc, [data-fh-atc]')) return true;
    if (/fh-pdp__atc|product-form__submit|add-to-cart|add_to_cart|(^|[^a-z])atc([^a-z]|$)/i.test(cls)) return true;
    var txt = (elm.textContent || '').trim().toLowerCase();
    return /add to (bag|cart)/.test(txt);
  }
  function nativeAtcFrom(elm) {
    while (elm && elm !== document) {
      if (looksLikeAtc(elm)) return elm;
      elm = elm.parentElement;
    }
    return null;
  }
  function nativeAtcButtons() {
    var out = [];
    var nodes = document.querySelectorAll('button, input[type="submit"], [role="button"]');
    Array.prototype.forEach.call(nodes, function (elm) { if (looksLikeAtc(elm)) out.push(elm); });
    return out;
  }

  function setBtnText(btn, text) {
    var target = btn.querySelector('.fh-pdp__atc-text, .product-form__submit-text, [data-add-to-cart-text], .btn__text, .btn-text');
    if (target) { target.textContent = text; return; }
    var span = btn.querySelector('span');
    if (span && !span.children.length) { span.textContent = text; return; }
    if (!btn.children.length) { btn.textContent = text; return; }
    btn.textContent = text;
  }

  var _origLabel = (typeof WeakMap === 'function') ? new WeakMap() : null;
  function syncNativeAtc() {
    var bundling = isBundleTier();
    var missing = missingSlots();
    var cfg = tierCfg(activeTier);
    nativeAtcButtons().forEach(function (btn) {
      if (_origLabel && !_origLabel.has(btn)) _origLabel.set(btn, btn.innerHTML);
      if (bundling) {
        var want = missing.length
          ? 'Pick set two'
          : 'Add ' + cfg.qty + ' sets — ' + money(cfg.total);
        if ((btn.textContent || '').replace(/\s+/g, ' ').trim() !== want) setBtnText(btn, want);
      } else if (_origLabel && _origLabel.has(btn)) {
        var orig = _origLabel.get(btn);
        if (btn.innerHTML !== orig) btn.innerHTML = orig;
      }
    });
  }

  function bindNativeAtc() {
    document.addEventListener('click', function (e) {
      if (!isBundleTier()) return;              // 1 set -> theme adds normally
      var btn = nativeAtcFrom(e.target);
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      doBundleAdd(btn);
    }, true);

    document.addEventListener('submit', function (e) {
      if (!isBundleTier()) return;
      var form = e.target;
      if (form && form.querySelector && nativeAtcButtons().some(function (b) { return form.contains(b); })) {
        e.preventDefault();
        e.stopImmediatePropagation();
        doBundleAdd(nativeAtcButtons()[0] || null);
      }
    }, true);

    var t = null;
    function resync() { if (t) return; t = setTimeout(function () { t = null; syncNativeAtc(); }, 60); }
    if (typeof MutationObserver === 'function') {
      new MutationObserver(resync).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', resync, true);
  }

  /* ---------- boot ----------
     Reconcile prices FIRST, so nothing — not the tier card, not the ATC label —
     is ever built from a number Kaching disagrees with. */
  reconcilePricing();
  ALL_SLOTS.forEach(function (s) { if (el('products', s)) renderSlot(s); });
  bindNativeAtc();
  refresh();
  bindDrawerControls();
})();
